// extracted by mini-css-extract-plugin
export default {"productCarousel":"h1-z"};